export default "<!--<h2>{{ title }}</h2>-->\r\n<div #chart id=\"chart\" width=\"100%\" height=\"100%\" (window:resize)=\"onResize($event)\"></div>\r\n";